<template>
  <div v-if="!loader" class="container-fluid">
    <div v-if="dish" id="dish-edit" class="panel">

      <div class="header mb-3">{{ $t('#TR-edit-dish') }}</div>

      <div class="row">
        <div class="col-12 col-sm-6 col-xl-3 mb-3">
          <label> {{ $t('#TR-name') }}:</label>
          <b-form-input v-model="dish['name']" :state="!!dish['name']"></b-form-input>
        </div>
        <div class="col-12 col-sm-6 col-xl-3">
          <label> {{ $t('#TR-dish-group') }}:</label>
          <br>
          <b-button v-if="dish._selectedDishGroup"
                    block
                    :variant="!dish._selectedDishGroup.sifr
                      ? 'outline-danger'
                      : 'success'"
                    @click="openDishGroupSelectorModal">
            {{
              dish._selectedDishGroup.name ? dish._selectedDishGroup.name : $t('#TR-empty')
            }}
          </b-button>
        </div>
      </div>

      <div class="row  mb-3">
        <div class="col-12 col-sm-6 col-xl-3">
          <label>{{ $t('#TR-fiscal-group') }}:</label>
          <b-dropdown
            block
            split-variant="outline-success"
            variant="success"
            :text="dish._taxDishType
              ? dish._taxDishType.name
              : $t('#TR-empty')"
            menu-class="w-100"
            class="w-100">
            <b-dropdown-item v-for="(taxDishType, idx) in refs.TaxDishTypes"
                             :key="idx"
                             href="#"
                             @click="dish._taxDishType = taxDishType">
              {{ taxDishType.name }}
            </b-dropdown-item>

          </b-dropdown>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <label>{{ $t('#TR-modischemes') }}:</label>
          <b-dropdown
            block
            split-variant="outline-success"
            variant="success"
            :text="dish._modiScheme ? dish._modiScheme.name : 'Empty'"
            menu-class="w-100"
            class="w-100">

            <b-dropdown-item href="#"
                             @click="dish._modiScheme = null">
              {{ $t('#TR-empty') }}
            </b-dropdown-item>

            <b-dropdown-item v-for="(modiScheme, idx) in refs.ModiSchemes"
                             :key="idx"
                             href="#"
                             @click="dish._modiScheme = modiScheme">
              {{ modiScheme.name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <b-card no-body class="mb-3">
        <b-tabs v-model="tabIndex"
                fill
                small
                content-class="my-3">
          <b-tab active
                 :title="$t('#TR-prices')">
            <add-price :dish="dish"
                       :price-types="refs.PriceTypes">
            </add-price>
          </b-tab>
          <b-tab :title="$t('#TR-classifications')">
            <add-classifications
              :dish="dish"
              :classifications-types="refs.Classifications">
            </add-classifications>
          </b-tab>
          <b-tab :title="$t('#TR-barcodes')">
            <add-barcode
              :dish="dish">
            </add-barcode>
          </b-tab>
        </b-tabs>
      </b-card>

      <!--<div class="panel mb-3">
                <div class="row my-3">
                    <div class="col-3">
                        <b-button :pressed="editPrice"
                                  variant="success"
                                  block
                                  @click="editPrice = true">
                            <span class="mdi mdi-cached"></span>
                            <span class="d-none d-md-inline"> Prices</span>
                        </b-button>
                    </div>
                    <div class="col-3 offset-3">
                        <b-button :pressed="!editPrice"
                                  variant="success"
                                  block
                                  @click="editPrice = false">
                            <span class="mdi mdi-cached"></span>
                            <span class="d-none d-md-inline"> Classifications</span>
                        </b-button>
                    </div>
                </div>

                <div class="row">
                    <div v-show="editPrice" class="col-12">
                        <add-price :dish="dish"
                                   :price-types="refs.PriceTypes">
                        </add-price>
                    </div>

                    <div v-show="!editPrice" class="col-12">
                        <add-classifications :dish="dish"
                                             :classifications-types="refs.Classifications">
                        </add-classifications>
                    </div>
                </div>
            </div>
-->
      <div class="row">
        <div class="col-12">
          <button class="btn btn-success float-right"
                  :disabled="errDish"
                  @click="onSave">
            <span class="mdi mdi-content-save"></span>
            <span class="d-none d-md-inline"> {{ $t('#TR-save') }}</span>
          </button>
          <button class="btn btn-secondary float-right mr-3"
                  @click="onCancel">
            <span class="mdi mdi-close"></span>
            <span class="d-none d-md-inline"> {{ $t('#TR-cancel') }}</span>
          </button>
        </div>
      </div>


      <div v-if="saveLoader" class="small-loader">
        <i class="mdi mdi-rotate-right mdi-spin"></i>
      </div>

    </div>

    <dish-group-selector-modal
      ref="dishGroupSelectorModal"
      @selectDishGroup="selectDishGroup">
    </dish-group-selector-modal>

  </div>
</template>

<script>
  import { ApiDish, ApiDishGroup, ApiRefEditor } from '@/services/api';
  import DishGroupSelectorModal from '@/views/WebEditor/Dishes/DishGroupSelectorModal';
  import AddPrice from '@/views/WebEditor/Dishes/parts/EditAddPrice';
  import AddBarcode from '@/views/WebEditor/Dishes/parts/EditAddBarcode';
  import AddClassifications from '@/views/WebEditor/Dishes/parts/EditAddClassifications';
  import { EditorRefs } from '@/services/EditorRefs';
  import MSG from '@/services/notify';

  export default {
    name: 'DishesEdit',

    components: {
      DishGroupSelectorModal,
      AddPrice,
      AddClassifications,
      AddBarcode
    },

    data() {
      return {
        tabIndex: 0,
        loader: true,
        dishGuid: this.$route.params.guid,
        groupGuid: this.$route.params.group,
        errDish: null,
        dish: null,
        refs: {
          TaxDishTypes: [],
          Classifications: [],
          ModiSchemes: [],
          PriceTypes: []
        },
        editPrice: true,
        errorForm: [],
        saveLoader: false
      };
    },

    computed: {
      darkMode() {
        return this.$store.state.darkMode;
      }
    },

    async mounted() {
      await this.getRefs();
      await this.getDish();
      await this.prepareDish();

      this.loader = false;
    },

    methods: {
      async getDish() {

        if (!this.dishGuid) {
          await this.getNewDish();
          await this.getdishGroup();

          return;
        }

        const result = await ApiDish.get(this.dishGuid);

        if (result.error) {
          MSG.error(result.error, this);
        } else {
          result.data.prices = this.filterElements(result.data.prices);
          result.data.classifications = this.filterElements(result.data.classifications);
          this.dish = result.data;
          await this.getdishGroup();
        }
      },

      async getdishGroup() {

        this.$set(this.dish, '_selectedDishGroup', null);

        if (!this.dish.parent) {
          this.dish.parent = this.groupGuid;
        }

        const result = await ApiDishGroup.get(this.dish.parent);

        if (result.error) {
          MSG.error(result.error, this);
        } else {
          this.dish._selectedDishGroup = result.data;
        }
      },

      async getRefs() {

        this.refs = await EditorRefs.getRefs([
          'TaxDishTypes',
          'Classifications',
          'ModiSchemes',
          'PriceTypes'
        ], this);
      },

      async prepareDish() {

        const _modiScheme = EditorRefs.findElement(this.refs.ModiSchemes, 'sifr', this.dish.modiScheme);
        const _taxDishType = EditorRefs.findElement(this.refs.TaxDishTypes, 'sifr', this.dish.taxDishType);

        this.$set(this.dish, '_modiScheme', _modiScheme);
        this.$set(this.dish, '_taxDishType', _taxDishType);

        if (!this.dish.taxDishType) {
          this.dish.taxDishType = this.dish._taxDishType = this.refs.TaxDishTypes[0];
        }

        this.dish.prices.forEach(p => {
          const type = EditorRefs.findElement(this.refs.PriceTypes, 'sifr', p.sifr);
          if (type) {
            type.selected = true;
          }
          this.$set(p, 'type', type);
        });

        for (let c of this.dish.classifications) {
          const type = EditorRefs.findElement(this.refs.Classifications, 'sifr', c.sifr);
          if (type) {
            type.selected = true;
          }
          this.$set(c, 'type', type);
          this.$set(c, 'catList', []);
          this.$set(c, 'cat', null);
          c = await this.prepareCats(c);
        }
      },

      async prepareCats(classification) {
        const result = await ApiRefEditor.getClassificationsCategories(classification.sifr);
        if (result.error) {
          MSG.error(result.error, this);
        } else {
          classification.catList = result.data;
          classification.cat = EditorRefs.findElement(classification.catList, 'sifr', classification.value);
        }

        return classification;
      },

      getNewDish() {
        this.dish = {
          modiScheme: null,
          barcodes: [],
          prices: [],
          classifications: [],
          taxDishType: null,
          extCode: null,
          code: null,
          guid: null,
          sifr: null,
          name: '',
          parent: null
        };
      },

      async onSave() {
        const options = JSON.parse(JSON.stringify(this.dish));

        options.barcodes = options.barcodes.filter(Boolean);

        options.modiScheme = options._modiScheme ? options._modiScheme.sifr : null;
        options.taxDishType = options._taxDishType ? options._taxDishType.sifr : null;
        options.parent = options._selectedDishGroup ? options._selectedDishGroup.sifr : null;

        delete options._selectedDishGroup;
        delete options._modiScheme;
        delete options._taxDishType;

        for (const p of options.prices) {
          p.sifr = p.type.sifr;
          delete p.type;
        }

        for (const c of options.classifications) {

          c.sifr = c.type ? c.type.sifr : null;
          c.value = c.cat ? c.cat.sifr : null;

          delete c.type;
          delete c.cat;
          delete c.catList;
        }

        const errors = this.validateDish(options);

        if (errors.length > 0) {
          this.errorForm = errors;

          errors.forEach(e => {
            MSG.error(e, this);
          });

          return;
        }

        this.delEmptyPriceClassifications(options);

        if (options.guid) {
          this.addEmptyPriceClassifications(options);
        }

        this.saveLoader = true;

        let result;
        if (!options.guid) {
          result = await ApiDish.add(options);
        } else {
          result = await ApiDish.update(options);
        }

        if (result.error) {
          MSG.error(result.error, this);
          this.saveLoader = false;
        } else {
          this.saveLoader = false;
          MSG.success(this.$t('#TR-dish-saved'), this);
          this.$router.push({
            name: 'dishes',
            params: {
              group: this.groupGuid
            }
          }).catch(() => {
          });
        }
      },

      addEmptyPriceClassifications(options) {

        const arrClass = [];
        this.refs.Classifications.forEach(c => {
          arrClass.push({
            sifr: c.sifr,
            value: null
          });
        });
        options.classifications = this.mergeArray(options.classifications, arrClass, 'sifr');

        const arrPrice = [];
        this.refs.PriceTypes.forEach(p => {

          if (p.sifr) {
            arrPrice.push({
              sifr: p.sifr,
              value: null
            });
          }
        });
        options.prices = this.mergeArray(options.prices, arrPrice, 'sifr');

        return options;
      },

      mergeArray(array, array2, param) {
        array.forEach(item => {
          const find = array2.findIndex(el => el[param] === item[param]);
          if (find !== -1) {
            array2[find] = item;
          }
        });

        return array2;
      },


      delEmptyPriceClassifications(options) {

        options.prices = options.prices.filter(item => {
          return item.sifr && (item.value || item.value === 0);
        });

        options.classifications = options.classifications.filter(item => {
          return item.sifr && item.value;
        });

        return options;
      },


      validateDish(options) {
        const error = [];
        if (!options.name) {
          error.push(this.$t('#TR-enter-name'));
        }

        return error;
      },

      onCancel() {
        this.$router.push({
          name: 'dishes',
          params: {
            group: this.groupGuid
          }
        }).catch(() => {
        });
      },

      openDishGroupSelectorModal() {
        this.$refs.dishGroupSelectorModal.openDishGroupSelectorView();
      },

      selectDishGroup(group) {
        this.dish._selectedDishGroup = group;
      },

      /* linkClass(idx) {
        if (this.tabIndex === idx) {
          return [
            'bg-success',
            'text-white'
          ];
        } else {

          return this.darkMode
            ? ['bg-grey-900', 'color-grey-500']
            : ['bg-light', 'text-secondary'];
        }
      }, */

      filterElements(arr) {
        return arr.filter(item => {
          return item.value || item.value === 0;
        });
      }

    }
  };
</script>

<style lang="stylus">

#dish-edit {

  .width-500 {
    max-width: 500px
  }

  .nav-tabs .nav-link {
    background: md-grey-200
    color: md-grey-700
    border: 1px solid white

    &.active {
      background: c-accent
      color: md-white
    }
  }
}

.darkmode {
  #dish-edit {
    .nav-tabs {
      border-bottom: 1px solid c-dark-bg;
    }
    .nav-tabs .nav-link {
      background: c-dark-bg
      color: c-body-font-dark
      border: 1px solid c-dark-bg-light

      &.active {
        background: c-accent-dark
        color: c-body-font-dark
      }
    }
  }
}

</style>
